<template>
    <div class="page">
        <!-- 顶部 -->
        <!-- 下拉面板 -->
        <panel
            ref="panel"
            wapTitle="拍卖数据"
            :appLink="appLink"
            :extinfo="extinfo"
            :spreadID="0"
            :showNav="true"
            isShowNav="true"
            showLogin="true"
            @gotoApp="gotoApp"
            :isApp="false"
            @heightChange="headerHeightChange"
        ></panel>
        <DownLoadApp ref="downloadPop"></DownLoadApp>
        <watermark v-if="showWater"></watermark>

        <!-- tab页面 -->
        <div class="auctionList">
            <van-tabs v-model="num" @change="changeTab">
                <van-tab title="正在拍卖" :name="0">
                    <auctioning ref="auctioning" :headerHeight="headerHeight" />
                </van-tab>
                <van-tab title="即将拍卖" :name="1">
                    <upcoming ref="upcoming" :headerHeight="headerHeight" />
                </van-tab>
                <van-tab title="拍卖结果" :name="2">
                    <results ref="results" :headerHeight="headerHeight" />
                </van-tab>
            </van-tabs>
        </div>
    </div>
</template>

<script>
import panel from './component/panel.vue'
import DownLoadApp from '@/components/common/downloadApp'
import watermark from '@/components/common/watermark'
// import { getWXConfig } from '@/assets/js/weixinShare'
import auctioning from '@/views/preview/component/auctioning.vue'
import upcoming from '@/views/preview/component/upcoming.vue'
import results from '@/views/preview/component/results.vue'
// import { history } from '@/api/auction'

export default {
    components: {
        panel,
        DownLoadApp,
        watermark,
        auctioning,
        upcoming,
        results
    },
    data() {
        return {
            headerHeight: 0,
            // 是否显示水印
            showWater: false,
            // 当前激活的菜单栏
            num: Number(this.$route.query.active) || 0,
            // 通链接数据
            appLink: '/2/8/0',
            extinfo:"",
            param: {
                page: 1,
                status: 0,
                only_meta: 1
            },
            meta: {}
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                {
                    name: 'description',
                    content: this.meta.description
                },
                {
                    name: 'keywords',
                    content: this.meta.keywords
                }
            ]
        }
    },
    methods: {
        headerHeightChange(val) {
            document.querySelector('.van-tabs__wrap').style.top = val - 1 + 'px'
            this.headerHeight = val
        },
        gotoApp() {
            this.$refs.downloadPop.gotoAppDownload(this.appLink, 0)
        },
        changeTab(name) {
            let that = this;
            let newUrl = new URL(window.location.href)
            newUrl.searchParams.set('active', name)
            window.history.replaceState(null, null, newUrl.href)
            this.extinfo=JSON.stringify({url: "preview",param: (name+1).toString()})
            // this.$nextTick(()=>{
            //         switch (name) {
            //         case 0:
            //             that.$refs.auctioning.setWxConfig()
            //             break;
            //         case 1:
            //             that.$refs.upcoming.setWxConfig()
            //             break;
            //         case 2:
            //             that.$refs.results.setWxConfig()
            //         break;
            //         }
            // })
            
        },

        // getMeta() {
        //     history({ type: 20 }).then(res => {
        //         if (res.code === 0) {
        //             this.meta = res.data.meta

        //             window.AFedWxShareData = {
        //                 title: this.meta.shareTitle,
        //                 imgUrl: this.meta.pic || 'https://pubunder.artron.net/pubimgs/m/wxImgAuc.png',
        //                 desc: this.meta.description || '',
        //                 link: window.location.href
        //             }
        //             getWXConfig(window.AFedWxShareData)
        //         }
        //     })
        // }
    },
    mounted() {
        let from = this.$route.query.from
        this.showWater = [1, 2].includes(Number(from))
        this.extinfo=JSON.stringify({url: "preview",param: '1'})
        // this.getMeta()
    }
}
</script>

<style scoped lang="scss">
.page {
    /deep/ #topHeader {
        .headerTop {
            box-shadow: none;
        }
    }
    .auctionList {
        width: 100%;
        /deep/ .van-tabs {
            width: 100%;
            .van-tabs__wrap {
                height: 2rem;
                border-bottom: .5px solid #E2E3E4;
                position: fixed;
                left: 0;
                //top: 5.725rem;
                width: 100%;
                z-index: 100;
                .van-tabs__nav {
                    padding-left: .2rem;
                    padding-right: .2rem;
                    .van-tab {
                        flex: none;
                        margin: 0 .6rem;
                        padding: 0;
                        .van-tab__text {
                            font-size: 0.75rem;
                            font-family: SF Pro-Regular, SF Pro;
                            font-weight: 400;
                            color: #6B6C6C;
                            line-height: 0.75rem;
                        }
                        &.van-tab--active {
                            .van-tab__text {
                                font-size: 0.8rem;
                                font-weight: bold;
                                color: #000000;
                                line-height: 0.8rem;
                            }
                        }
                    }
                    .van-tabs__line {
                        width: 1.55rem;
                        height: 0.2rem;
                        background: linear-gradient(90deg, #18A974 0%, rgba(24, 169, 116, 0) 100%);
                        border-radius: 0;
                        opacity: 1;
                        bottom: 1.2rem;
                        left: -.85rem;
                    }
                }
            }
            .van-tabs__content {
                padding: 2rem .8rem .8rem;
                position: relative;
                padding-bottom: calc(.8rem + constant(safe-area-inset-bottom));
                padding-bottom: calc(.8rem + env(safe-area-inset-bottom));
                &::before {
                    position: absolute;
                    left: 0;
                    top: -2rem;
                    display: block;
                    content: '';
                    width: 100%;
                    height: 8.9rem;
                    background: linear-gradient(180deg, #FFFFFF 63%, rgba(255, 255, 255, 0) 97%);
                    z-index: -1;
                }
            }
        }
    }
   
    .loading {
        position: fixed;
        z-index: 9999;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: #fff;
    }
}
</style>